export default __webpack_public_path__ + "static/media/Vector.3b42b7e6.svg";